module.exports = __webpack_public_path__ + "img/header-bg.2b8bc3ec.png";